import Vue from 'vue'
import VueRouter from 'vue-router'
import StudentView from '../views/StudentView.vue'
import TeacherView from '../views/TeacherView.vue'
import SchoolView from '../views/SchoolView.vue'
import LoginView from '../views/LoginView.vue'
import TeacherProfile from '../views/teacherPage/teacherProfile.vue'
import TeacherManagement from '../views/teacherPage/teacherManagement.vue'
import TeacherGroup from '../views/teacherPage/teacherGroup.vue'
import TeacherCaseTags from '../views/teacherPage/teacherCaseTags.vue'
import TeacherPatients from '../views/teacherPage/teacherPatients.vue'
import TeacherTests from '../views/teacherPage/teacherTests.vue'
import TeacherReports from '../views/teacherPage/teacherReports.vue'
import StudentProfile from '../views/studentPage/studentProfile.vue'
import StudentExam from '../views/studentPage/studentExam.vue'

import StudentPatients from '../views/studentPage/studentPatients.vue'
import StudentPatientV2 from '../views/studentPage/studentPatients.v2.vue'
import StudentReport from '../views/studentPage/studentReport.vue'
import SchoolProfile from '../views/schoolPage/schoolProfile.vue'
import SchoolDepartment from '../views/schoolPage/schoolDepartment.vue'
import SchoolManagement from '../views/schoolPage/schoolManagement.vue'
import SchoolReports from '../views/schoolPage/schoolReports.vue'
import AdminView from '../views/AdminView.vue'
import AdminProfile from '../views/adminPage/adminProfile.vue'
import AdminSchool from '../views/adminPage/adminSchool.vue'
import AdminManagement from '../views/adminPage/adminManagement.vue'
import AdminReports from '../views/adminPage/adminReports.vue'

Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
    meta: {
      title: '登入 - OSCE'
    }
  },
  {
    path: '/student',
    name: 'student',
    component: StudentView,
    meta: {
      title: 'Home - OSCE'
    },
    children: [
      {
        path: 'profile',
        name: 'studentProfile',
        component: StudentProfile
      },
      {
        path: 'exam',
        name: 'studentExam',
        component: StudentExam
      },
      {
        path: 'patients',
        name: 'studentPatients',
        component: StudentPatients
      },
      {
        path: 'patientsv2',
        name: 'studentPatientsV2',
        component: StudentPatientV2
      },
      {
        path: 'report',
        name: 'studentReport',
        component: StudentReport
      }
    ]
  },
  {
    path: '/teacher',
    name: 'teacher',
    component: TeacherView,
    meta: {
      title: 'Home - OSCE'
    },
    children: [
      {
        path: 'profile',
        name: 'teacherProfile',
        component: TeacherProfile
      }, {
        path: 'management',
        name: 'teacherManagement',
        component: TeacherManagement
      }, {
        path: 'groups',
        name: 'teacherGroup',
        component: TeacherGroup
      }, {
        path: 'caseTags',
        name: 'teacherCaseTags',
        component: TeacherCaseTags
      }, {
        path: 'patients',
        name: 'teacherPatients',
        component: TeacherPatients
      }, {
        path: 'tests',
        name: 'teacherTests',
        component: TeacherTests
      }, {
        path: 'reports',
        name: 'teacherReports',
        component: TeacherReports
      }
    ]
  },
  {
    path: '/school',
    name: 'school',
    component: SchoolView,
    meta: {
      title: 'Home - OSCE'
    },
    children: [
      {
        path: 'profile',
        name: 'schoolProfile',
        component: SchoolProfile
      },
      {
        path: 'management',
        name: 'schoolManagement',
        component: SchoolManagement
      },
      {
        path: 'department',
        name: 'schoolDepartment',
        component: SchoolDepartment
      },
      {
        path: 'reports',
        name: 'schoolReports',
        component: SchoolReports
      }
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    meta: {
      title: 'Home - OSCE'
    },
    children: [
      {
        path: 'profile',
        name: 'adminProfile',
        component: AdminProfile
      },
      {
        path: 'school',
        name: 'adminSchool',
        component: AdminSchool
      },
      {
        path: 'management',
        name: 'adminManagement',
        component: AdminManagement
      },
      {
        path: 'reports',
        name: 'adminReports',
        component: AdminReports
      }
    ]
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
